module.exports="abcwebpack"


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/module-description-file/~/testloader/lib/loader-indirect.js!./loaders/_resources/abc.txt
 ** module id = 3
 ** module chunks = 0
 **/